import { jsx as _jsx } from "react/jsx-runtime";
export function WarningBox(_a) {
    var children = _a.children;
    return (_jsx("div", { className: "mt-4 rounded-xl border border-amber-200 bg-amber-50 px-3 py-2 text-sm font-semibold text-amber-800", children: children }));
}
